import { render } from "./VitalsAlerts.vue?vue&type=template&id=49aa4b37&scoped=true"
import script from "./VitalsAlerts.vue?vue&type=script&lang=js"
export * from "./VitalsAlerts.vue?vue&type=script&lang=js"

import "./VitalsAlerts.vue?vue&type=style&index=0&id=49aa4b37&scoped=true&lang=css"

import exportComponent from "/home/runner/work/medsien-patient-app/medsien-patient-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49aa4b37"]])

export default __exports__